<template v-if="package">
  <a :id="id"></a>
</template>

<script>
export default {
  props: ['package', 'size', 'color'],
  data () {
    return {
      id: -1,
      mutableSize: this.size || 'small',
      mutableColor: this.color || 'silver'
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.currentUser
    },
    packageId () {
      return this.package.id
    }
  },
  mounted () {
    this.id = `p${this._uid}`
    var that = this
    this.$nextTick(() => {
      paypal.Button.render({
        env: `${PAYPAL_MODE}`,
        style: {
          size: this.mutableSize,
          shape: 'rect',
          color: this.mutableColor
        },
        commit: true,
        payment: function (resolve, reject) {
          if (!that.currentUser || !that.currentUser.id) {
            // that.$router.push('/register')
            // that.$root.$refs.toastr.w('Please log in to purchase')
            return reject(new Error('User is not logged in'))
          }
          const CREATE_PAYMENT_URL = `${BASE_URL}/payment`
          paypal.request.post(CREATE_PAYMENT_URL, {id: that.packageId, userID: that.currentUser.id})
              .then(function (data) {
                resolve(data.paymentID)
              })
              .catch(function (err) { reject(err) })
        },
        onAuthorize: function (data, actions) {
          const EXECUTE_PAYMENT_URL = `${BASE_URL}/payment/execute`
          paypal.request.post(EXECUTE_PAYMENT_URL,
                  { paymentID: data.paymentID, payerID: data.payerID, userID: that.currentUser.id, packageID: that.packageId })
              .then(function (data) { that.$router.push('/paymentsuccess') })
              .catch(function (err) { console.log(err) })
        },
        onClick: function () {
          if (!that.currentUser || !that.currentUser.id) {
            that.$root.$refs.toastr.w('Please log in or register to become a Premium Member')
            return that.$router.push('/register')
          }
        },
        onCancel: function (data, actions) {
        },
        onError: function (err) {
          if (err && err.message && err.message.indexOf('User is not logged in') < 0) {
            console.log(err)
            that.$root.$refs.toastr.e('An error occurred processing the payment, please contact support@stumpthespread.com')
          }
        }
      }, `#${this.id}`)
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// paypalButton.vue?ef46c092